function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "shape0",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0.182874589267612)",
  fill: "currentColor",
  d: "M74.2014 197.862L0 197.862L98.9437 296.806L197.896 197.862L123.694 197.862C123.933 116.008 190.227 49.7057 272.08 49.4591C296.176 49.9182 319.856 55.836 341.333 66.7787L378.421 29.6908C346.052 10.9597 309.466 0.739718 272.08 0C162.925 0.297588 74.5075 88.7067 74.2014 197.862ZM420.466 197.862C420.228 279.715 353.934 346.018 272.08 346.265C247.984 345.805 224.305 339.888 202.827 328.945L165.739 366.033C198.108 384.764 234.695 394.984 272.08 395.724C381.227 395.409 469.636 307.009 469.959 197.862L544.16 197.862L445.217 98.9182L346.265 197.862Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "group0",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "group1",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "group2",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "group3",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "group4",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "group5",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "group6",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  id: "group7",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  id: "group8",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  id: "group9",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  id: "group10",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  id: "group11",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  id: "group12",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  id: "group13",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var _ref17 =
/*#__PURE__*/
React.createElement("g", {
  id: "group14",
  transform: "matrix(0.0045000001937151 0 0 0.00393750016950072 0 0)",
  fill: "none"
});

var SvgRepeat = function SvgRepeat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "2.304pt",
    height: "2.016pt",
    viewBox: "0 0 2.304 2.016",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRepeat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/repeat.711cc56f.svg";
export { ForwardRef as ReactComponent };